// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__EPC0_","addWidgetButton":"Header_addWidgetButton__2wCfL","dashboardTabs":"Header_dashboardTabs__DgqTe","active":"Header_active__2QNUU"};